import React from 'react';
import { colors } from 'styleguide';

interface Props {
  size?: number;
  color?: string;
}

const ListBullet = ({ size = 16, color = colors('neutral', 3) }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="5.7334"
      y1="3.8667"
      x2="18.6667"
      y2="3.8667"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="1.93333" cy="3.93333" r="0.933333" fill={color} />
    <circle cx="1.93333" cy="9.53343" r="0.933333" fill={color} />
    <circle cx="1.93333" cy="15.0667" r="0.933333" fill={color} />
    <line
      x1="5.73334"
      y1="15"
      x2="18.6667"
      y2="15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="5.7334"
      y1="9.4668"
      x2="18.6667"
      y2="9.4668"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ListBullet;
